<template>
    <nav>
      <OrdersPageFilterComponent
        :filters="filter"
        :show-delivery-options="false"
        :show-payment-options="false"
        @orders-page-filter:updated="onFilterUpdated"
      />
    </nav>
  
    <!-- Заявки на оплату -->
    <PaymentRequestsRegistry :params="registryParams" />
  </template>
  
  <script lang="ts">
  import OrdersPageFilterComponent from '@/domains/Orders/components/OrdersFlow/OrdersPageFilter/OrdersPageFilterComponent.vue';
  import OrdersPageFilter from '@/domains/Orders/components/OrdersFlow/OrdersPageFilter/OrdersPageFilter';
  import PaymentRequestsRegistry   from '@/domains/PaymentRequests/components/PaymentRequestsRegistry/PaymentRequestsRegistry.vue';
  
  export default defineComponent({
    name: 'PaymentRequestsPage',
  
    components: {
      OrdersPageFilterComponent,
      PaymentRequestsRegistry,
    },
  
    data() {
      return {
        filter: OrdersPageFilter.fromLocalStorage(),
      };
    },
  
    computed: {
      registryParams() {
        const params = this.filter.getRequestParams();
  
        // У фильтра есть 2 доп. поля реестра «в работе», которых в платежах
        // быть не должно — удаляем их.
        params.paymentStatus  = undefined;
        params.deliveryStatus = undefined;
  
        return {
          ...params,
        };
      },
    },
  
    methods: {
      /** Применили фильтр — реестр перезапросится сам по реактивным params */
      onFilterUpdated(newFilter: OrdersPageFilter) {
        this.filter = newFilter;
      },
    },
  });
  </script>